import ManualInvoice from '@/views/invoices/Manual.vue'

const router = {
  path: '/invoices/manual',
  name: 'Manual Invoices',
  component: ManualInvoice,
  meta: {
    title: 'Manual Invoices'
  }
}

export default router